'use client';

import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import React from 'react';

type Props = {
  onClose: () => void;
  onGoBackSelect: () => void;
};

export const Error: React.FC<Props> = ({ onClose, onGoBackSelect }) => {
  const t = useTranslations('monetization');

  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <div className='flex flex-col h-[200px] py-[40px] w-full items-center justify-center'>
          <Image src='/assets/icons/lets-icons_sad.svg' width={48} height={48} alt='sad' />
          <DialogTitle asChild>
            <div className='mt-[12px] text-center text-[18px] font-medium'>{t('payment_error_title')}</div>
          </DialogTitle>

          <Button onClick={onGoBackSelect} className='w-full h-auto mt-[24px] py-[10px]'>
            {t('payment_error_back_to_methods')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
